var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNearbyAmenities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2113 6.66663C15.2913 7.09929 15.3333 7.54463 15.3333 7.99996C15.3333 12.05 12.05 15.3333 7.99996 15.3333C3.94996 15.3333 0.666626 12.05 0.666626 7.99996C0.666626 3.94996 3.94996 0.666626 7.99996 0.666626C9.31996 0.666626 10.5566 1.01329 11.6266 1.62396M11.3333 7.99996C11.3333 9.84091 9.84091 11.3333 7.99996 11.3333C6.15901 11.3333 4.66663 9.84091 4.66663 7.99996C4.66663 6.15901 6.15901 4.66663 7.99996 4.66663C9.84091 4.66663 11.3333 6.15901 11.3333 7.99996ZM8.66663 7.99996C8.66663 8.36815 8.36815 8.66663 7.99996 8.66663C7.63177 8.66663 7.33329 8.36815 7.33329 7.99996C7.33329 7.63177 7.63177 7.33329 7.99996 7.33329C8.36815 7.33329 8.66663 7.63177 8.66663 7.99996ZM15.3333 2.66663C15.3333 3.7712 14.4379 4.66663 13.3333 4.66663C12.2287 4.66663 11.3333 3.7712 11.3333 2.66663C11.3333 1.56206 12.2287 0.666626 13.3333 0.666626C14.4379 0.666626 15.3333 1.56206 15.3333 2.66663Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearbyAmenities);
export default __webpack_public_path__ + "static/media/nearby-amenities.9a839bcb.svg";
export { ForwardRef as ReactComponent };